import { MapPin, Clock, Phone, Navigation, Instagram, Mail } from "lucide-react";
import { ADDRESS, PHONE, WA, MAP_EMBED, MAP_ROUTE, INSTAGRAM, EMAIL } from "./data";
import { Reveal, Eyebrow } from "./motion";

const Row = ({ icon: I, label, children, testid }) => (
  <div className="flex gap-4 py-5 border-b border-white/10" data-testid={testid}>
    <I className="w-5 h-5 text-[#FF6A13] shrink-0 mt-1" />
    <div><p className="font-mono text-[11px] uppercase tracking-[0.2em] text-white/60">{label}</p><div className="mt-1.5 text-white">{children}</div></div>
  </div>
);

export const Visit = () => (
  <section id="visite" className="relative bg-[#0A0E3F] text-white py-24 md:py-36 overflow-hidden" data-testid="visit-section">
    <div className="max-w-[1400px] mx-auto px-5 md:px-10 grid lg:grid-cols-12 gap-12">
      <Reveal className="lg:col-span-5">
        <Eyebrow>Como chegar</Eyebrow>
        <h2 className="mt-6 font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-[-0.03em] leading-[0.95]">Passa aqui <span className="italic text-[#FF6A13]">na loja.</span></h2>
        <div className="mt-10">
          <Row icon={MapPin} label="Endereço" testid="visit-address">{ADDRESS}</Row>
          <Row icon={Clock} label="Horário" testid="visit-hours"><span className="font-display text-2xl font-bold">08:00 – 17:00</span></Row>
          <Row icon={Phone} label="Telefone / WhatsApp" testid="visit-phone"><a href={WA} target="_blank" rel="noreferrer" className="hover:text-[#FFB020] transition-colors">{PHONE}</a></Row>
          <Row icon={Mail} label="E-mail" testid="visit-email"><a href={`mailto:${EMAIL}`} className="hover:text-[#FFB020] transition-colors">{EMAIL}</a></Row>
        </div>
        <div className="mt-10 flex flex-wrap gap-3">
          <a href={MAP_ROUTE} target="_blank" rel="noreferrer" data-testid="visit-route-btn" className="group inline-flex items-center gap-2 rounded-full bg-[#FF6A13] text-[#0A0E3F] font-semibold px-6 py-3.5 hover:bg-[#FFB020] transition-colors">
            <Navigation className="w-4 h-4 transition-transform duration-300 group-hover:rotate-12" /> Traçar rota
          </a>
          <a href={INSTAGRAM} target="_blank" rel="noreferrer" data-testid="visit-instagram-btn" className="inline-flex items-center gap-2 rounded-full border border-white/25 px-6 py-3.5 hover:border-white hover:bg-white/5 transition-colors">
            <Instagram className="w-4 h-4" /> @rsilva.aquecedores
          </a>
        </div>
      </Reveal>
      <Reveal className="lg:col-span-7" delay={0.15}>
        <div className="relative h-[380px] md:h-full md:min-h-[560px] rounded-[28px] overflow-hidden ring-1 ring-white/15" data-testid="visit-map">
          <iframe title="Mapa RSilva Bombas e Aquecedores" src={MAP_EMBED} className="absolute inset-0 w-full h-full border-0 grayscale-[30%] contrast-[1.05]" loading="lazy" referrerPolicy="no-referrer-when-downgrade" allowFullScreen />
        </div>
      </Reveal>
    </div>
  </section>
);
